import axios from "axios";
import * as d3 from "d3";
import {numberFormat, pieChart} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    var url2 = '/api/fetchDataWithParam/' + chart.data.vizSpecific4 + '/Any'
    console.log("Chart vizName called:", vizName, divId, url)

    // load the data
    axios.post(url, filterParam).then(res => {
        let data = res.data;
        console.log("data is:", data)

        var types = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .entries(data);

        console.log("types", types)

        //  var width = 600, height = 300;
        var svg = d3.select(divId).selectAll("svg").remove();
        svg = d3.select(divId)
            .selectAll('svg')
            .data(types)
            .enter()
            .append('svg')
            .attr('width', chart.width)
            .attr('height', chart.height)
        //   .call(responsivefy)
        // .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        var
            radius = 100;
        console.log("radius", radius)

        var div = d3.select(divId).append("div").attr("class", "toolTip");

        //    var div2 = d3.select(divId).append("div")

        var g = svg.append("g")
            .attr("transform", "translate(" + chart.width / 2 + "," + chart.height / 1.8 + ")");


        var color = d3.scaleOrdinal().range(pieChart);


        var pie = d3.pie()
            .value(function (d) {
                return d.metric1;
            }).sort(null);

        axios.post(url2, filterParam).then(res => {

            let data2 = res.data.rowsData;

            console.log("data2", data2)
            var tots = data2.map(function (d) {
                return d.metric1;
            });

            console.log("tots", tots)


            console.log("datapie", data)

            var path = d3.arc()
                .outerRadius(radius - 5)
                .innerRadius(40);


            var arc = g.selectAll(".arc")
                .data(function (d) {
                    return pie(d.values)
                })
                .enter().append("g")
                .attr("class", "arc");


            arc.append("path")
                .attr("d", path)
                .attr("fill", function (d) {
                    // return chart.x1AxisDisplayName == "accidents" ? color3(d.data.dim2_name) :
                    //     chart.x1AxisDisplayName == "Fatal" ? color2(d.data.dim2_name) :
                    //         chart.x1AxisDisplayName == "Injuries" ? color4(d.data.dim2_name) :
                    return color(d.data.dim2_name);
                })
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(d.data.dim2_name + '<br>' +
                        Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + numberFormat(d.data.metric1) + ' out of ' + numberFormat(tots) + ')')
                        .style("display", "block")
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition()
                        .style("display", "none")
                        .style("opacity", 0)
                });

            arc.append("svg:text")                                     //add a label to each slice
                .attr("transform", function (d) {                    //set the label's origin to the center of the arc
                    //we have to make sure to set these before calling arc.centroid
                    d.innerRadius = 0;
                    d.outerRadius = 40;
                    return "translate(" + path.centroid(d) + ")";        //this gives us a pair of coordinates like [50, 50]
                })
                .attr("text-anchor", "middle")                          //center the text on it's origin
                .text(function (d) {
                    return numberFormat(d.data.metric1)
                });

            // var label = g
            //   //  .selectAll("g")
            //     .data(types)
            //
            // label.append("rect")
            //     .attr("x",-100)
            //     .attr("y",-230)
            //     .attr("width",300)
            //     .attr("height",50)
            //     .attr("fill",function(){ return chart.x1AxisDisplayName == 'Accidents' ? "blue" : chart.x1AxisDisplayName == 'Fatal' ? "red" : chart.x1AxisDisplayName == 'Injuries' ? "orange" : "grey" })
            //     .attr("stroke","black")
            //     .style("display",function(d,i){ return types[i] ==types[parseInt((types.length-1)/2)]  ? "block":"none"})
            //
            //    label.append("text")
            //     .attr("x", 20)
            //     .attr("y", -205)
            //     .attr('font-weight', 'bold')
            //        .style('text-anchor', 'middle')
            //        .attr("dominant-baseline", "central")
            //        .attr('font-size','25px')
            //        .attr('fill','white')
            //     .style("display",function(d,i){ return types[i] ==types[parseInt((types.length-1)/2)]  ? "block":"none"})
            //     .text(chart.x1AxisDisplayName + colonAnnotation + numberFormat(tots))
            //
            // console.log(label)


            var title = svg.append("g")
                .data(types)
                .append("text")
                .attr("x", 150)
                .attr("y", 120)
                .style('text-anchor', 'middle')
                .attr("dominant-baseline", "central")
                .attr('font-weight', 'bold')
                .text(function (d) {
                    return d.key
                })

            console.log(title)


            var legend = svg.append('g')
                .attr("class", "legend")
                .selectAll("g")
                .data(function (d) {
                    return pie(d.values)
                }, function (d) {
                    return d.data.dim2_name;
                })//setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
                .enter().append("g")
                .attr("transform", function (d, i) {
                    return "translate(0," + i * 20 + ")";
                });

            legend.append("rect")
                .attr('x', 40)
                .attr('y', 340)
                .attr("width", 18)
                .attr("height", 18)
                .style("fill", function (d) {
                    // return chart.x1AxisDisplayName == "accidents" ? color3(d.data.dim2_name) :
                    //     chart.x1AxisDisplayName == "Fatal" ? color2(d.data.dim2_name) :
                    //         chart.x1AxisDisplayName == "Injuries" ? color4(d.data.dim2_name) :
                    return color(d.data.dim2_name);
                });

            legend.append("text")
                .attr("x", 70)
                .attr("y", 350)
                .attr("dy", ".35em")
                .text(function (d) {
                    return Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + ' ' + d.data.dim2_name;
                });
        })
    })
}
